import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface Props {
  canPrev: boolean;
  canNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  label: string;
}
export function CarouselControls({
  canPrev,
  canNext,
  onPrev,
  onNext,
  label
}: Props) {
  const btn = 'flex h-10 w-10 items-center justify-center rounded-full border border-line bg-white text-ink transition-[border-color,opacity] duration-150 hover:border-ink disabled:cursor-not-allowed disabled:opacity-35 disabled:hover:border-line';
  return <div className="flex gap-2" data-id="element-88" data-mp="1o9nit1k8rwii">
      <button type="button" onClick={onPrev} disabled={!canPrev} className={btn} aria-label={`Vorige ${label}`} data-id="element-89" data-mp="1ji5h2bae9rwh">
        <ChevronLeftIcon className="h-5 w-5" data-id="element-90" data-mp="1ejkgubv57881" />
      </button>
      <button type="button" onClick={onNext} disabled={!canNext} className={btn} aria-label={`Volgende ${label}`} data-id="element-91" data-mp="1egyaugnwh0rx">
        <ChevronRightIcon className="h-5 w-5" data-id="element-92" data-mp="277q1yzq3yz8e" />
      </button>
    </div>;
}